/**
 * Atelier Couture — Shoppable Lookbook Hotspots
 * Interactive pins on campaign imagery with instant product preview & quick bag addition.
 */
class LookbookHotspots {
  constructor(container) {
    this.container = container;
    this.pins = container.querySelectorAll('.lookbook-pin');
    this.init();
  }

  init() {
    this.pins.forEach(pin => {
      pin.addEventListener('click', (e) => {
        e.stopPropagation();
        const isOpen = pin.classList.contains('is-open');
        this.closeAll();
        if (!isOpen) pin.classList.add('is-open');
      });
    });

    document.addEventListener('click', (e) => {
      if (!e.target.closest('.lookbook-pin')) {
        this.closeAll();
      }
    });
  }

  closeAll() {
    this.pins.forEach(p => p.classList.remove('is-open'));
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.lookbook-item').forEach(el => new LookbookHotspots(el));
});
